import React from 'react';
import s from "./LinkedInPostPreview.module.css";
import menu from "../../../../assets/img/menu.svg";
import comment from "../../../../assets/img/comment_instagram.svg";
import like from "../../../../assets/img/like_instagram.svg";
import send from "../../../../assets/img/share_instagram.svg"
import save from '../../../../assets/img/save_instagram.svg'
interface InstagramPostPreviewProps {
    image: string | null;
    text: string;
    highlightHashtags:(text:string)=>void
}

const InstagramPostPreview: React.FC<InstagramPostPreviewProps> = ({ image, text,highlightHashtags }) => {
    return (
        <div className={s.preview}>
            <div className={s.profileSection}>
                <div style={{display:'flex'}}>
                    <div className={s.profileImage}></div>
                    <div className={s.profileDetails}>
                        <div className={s.profileName}></div>
                        <div className={s.profileTitle}></div>

                    </div>
                </div>

                <img src={menu} className={s.menu} alt="Menu"/>
            </div>
            {image &&
                <div className={s.imageListInstagram}>

                    <img src={image} className={s.uploadedImageTwitter}/>

                </div>}
            <div className={s.commentsSharesSection}>
                <div className={s.actionButtonsInstagram}>
                    <div className={s.flex}>
                        <img src={like} className={s.inst_icon} alt="like"/>
                        <img src={comment} className={s.inst_icon} alt="comment"/>
                        <img src={send} className={s.inst_icon} alt="send"/>
                    </div>
                    <img src={save} className={s.inst_icon} alt="save"/>

                </div>
            </div>

            <div className={s.content}>
                <>
                {highlightHashtags(text)}
                </>

            </div>


        </div>
    )
        ;
};

export default InstagramPostPreview;
